/* eslint-disable no-magic-numbers */

import { HTTPStatusCodes } from '@omnipresentgroup/constants';
import { HttpResponse, http } from 'msw';

import { API_PATH } from './constants';
import { GET_PAYROLL_PROVIDERS_RESPONSE } from './fixtures';

export const payrollProviderHandlers = [
  http.get(`*${API_PATH}`, () =>
    HttpResponse.json(GET_PAYROLL_PROVIDERS_RESPONSE, {
      status: HTTPStatusCodes.OK,
    }),
  ),
  http.get(`*${API_PATH}/:id`, ({ params }) =>
    HttpResponse.json(
      GET_PAYROLL_PROVIDERS_RESPONSE.find(
        (provider) => provider.id === params.id,
      ) ?? {},
      {
        status: HTTPStatusCodes.OK,
      },
    ),
  ),
  http.post(`*${API_PATH}`, () =>
    HttpResponse.json(
      {},
      {
        status: HTTPStatusCodes.RESOURCE_CREATED,
      },
    ),
  ),
  http.put(`*${API_PATH}/:id`, () =>
    HttpResponse.json(
      {},
      {
        status: HTTPStatusCodes.OK,
      },
    ),
  ),
];
